module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/school4-311527a66aeac148ffd1755f9ad151f3.svg";